import { useState } from "react"
import { Accordion, AccordionContent, AccordionTitle } from "semantic-ui-react"

const ManualAccordion = ({header, children, active=false}) => {
    const [auxActive, setAuxActive] = useState(active)

    return <>
        <Accordion fluid styled>
            <AccordionTitle
                active={auxActive}
                index={0}
                onClick={() => setAuxActive(!auxActive)}
            >
                {header}
            </AccordionTitle>
            <AccordionContent active={auxActive}>
                {children}
            </AccordionContent>
        </Accordion>
    </>
}

export default ManualAccordion